import * as React from 'react';

export default function condition({small}){
    return(
        <>
        <h6>
        บริษัท ฮับสวิตช์ จำกัด (“บริษัทฯ” หรือ “เรา”) ตระหนักและให้ความสำคัญเกี่ยวกับการคุ้มครองความเป็นส่วนตัวและข้อมูลส่วนบุคคลของร้านค้าที่ใช้บริการแอปพลิเคชันหรือซอร์ฟแวร์ที่ชื่อว่า “HubSwitch Pro” (“HubSwitch”) และผู้ที่เยี่ยมชมเว็บไซต์ https://hubswitch.com (“เว็บไซต์”) เป็นอย่างยิ่ง บริษัทฯ จึงได้จัดทำนโยบายความเป็นส่วนตัวฉบับนี้ (“นโยบาย”) ขึ้นเพื่ออธิบายถึงวิธีการที่บริษัทฯ เก็บรวบรวม ใช้ และเปิดเผย (“ประมวลผล”) ข้อมูลส่วนบุคคลของร้านค้าที่ใช้บริการ HubSwitch Pro และผู้เยี่ยมชมเว็บไซต์ (เรียกรวมกันว่า “ท่าน”) เพื่อให้สอดคล้องกับพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (“กฎหมายคุ้มครองข้อมูลส่วนบุคคล”) ซึ่งรวมไปถึงคำอธิบายเกี่ยวกับรายละเอียดการประมวลผลข้อมูลส่วนบุคคลของท่านโดยบริษัทฯ และสิทธิต่าง ๆ ภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล ทางเราขอให้ท่านอ่านและทำความเข้าใจในนโยบายฉบับนี้โดยละเอียด เพื่อประโยชน์และความเข้าใจเกี่ยวกับการประมวลผลข้อมูลส่วนบุคคลและสิทธิของท่านภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคลเมื่อท่านได้ใช้บริการจากทางบริษัทฯ โดยมีรายละเอียดดังต่อไปนี้

 
</h6><h6>
1. วิธีการเก็บรวบรวมข้อมูลส่วนบุคคล

</h6><h6>

บริษัทฯ จะทำการเก็บรวบรวมข้อมูลส่วนบุคคลที่ได้รับโดยตรงจากท่านผ่านช่องทางและวิธีการดังต่อไปนี้

</h6><h6>

(1) เมื่อท่านได้กรอกข้อมูลบน เว็บไซต์ของบริษัทฯ หรือ HubSwitch Pro เพื่อสมัครสมาชิก

</h6><h6>

(2) เมื่อท่านได้ทำการระบุรายละเอียดเกี่ยวกับร้านค้าและการบริการของท่านบน HubSwitch Pro

</h6><h6>

(3) เมื่อท่านได้ตอบแบบสอบถามที่บริษัทฯ ได้มีการนำส่งให้แก่ท่าน

</h6><h6>

(4) เมื่อท่านได้เยี่ยมชมเว็บไซต์ของบริษัทฯ

</h6><h6>

(5) เมื่อท่านได้ทำการติดต่อบริษัทฯ เพื่อทำการสอบถาม ให้ความคิดเห็นหรือข้อเสนอแนะ หรือแจ้งข้อร้องเรียนที่ท่านได้พบเจอขณะใช้งาน HubSwitch Pro หรือเว็บไซต์ของบริษัทฯ

</h6><h6>

ทั้งนี้ บริษัทฯ อาจมีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากแหล่งข้อมูลอื่นที่บริษัทฯ สามารถเข้าถึงได้หรือแหล่งข้อมูลอื่นที่เป็นสาธารณะ เช่น พันธมิตรทางธุรกิจของบริษัทฯ หน่วยงานราชการ ผู้ให้บริการ เว็บไซต์สื่อประชาสัมพันธ์ต่าง ๆ หรือบุคลลภายนอกอื่น ๆ

</h6><h6>

2. ข้อมูลส่วนบุคคลที่มีการเก็บรวบรวม

</h6><h6>

บริษัทฯ มีการเก็บรวบรวมข้อมูลส่วนบุคคลที่สามารถใช้ในการระบุตัวตนของท่านได้ไม่ว่าทางตรงหรือทางอ้อม โดยข้อมูลส่วนบุคคลที่มีการเก็บรวบรวมโดยบริษัทฯ มีรายละเอียดดังต่อไปนี้

</h6><h6>

ข้อมูลระบุตัวตน เช่น ชื่อ นามสกุล อายุ วันเดือนปีเกิด เพศ รูปภาพ หมายเลขบัตรประจำตัวประชาชน/หนังสือเดินทาง ลายมือชื่ออิเล็กทรอนิกส์ เป็นต้น</h6><h6>
ข้อมูลการติดต่อ เช่น ที่อยู่ หมายเลขโทรศัพท์ อีเมล ที่อยู่สำหรับเรียกเก็บเงิน/ส่งใบเสร็จ เป็นต้น</h6><h6>
ข้อมูลการใช้งาน เช่น ชื่อผู้ใช้งาน/รหัสผ่าน ข้อมูลการจัดการร้านค้าบนแอปพลิเคชัน ข้อมูลการเข้าชมสื่อโฆษณาหรือเนื้อหาบนแอปพลิเคชัน ข้อมูลการปรับแต่งคุณลักษณะการใช้งาน ข้อมูลการนัดหมายลูกค้า ข้อมูลอื่น ๆ ที่เกี่ยวกับการใช้งานเป็นต้น</h6><h6>
ข้อมูลธุรกรรมและการเงิน เช่น รายละเอียดบัตรเครดิต รายละเอียดบัญชีธนาคาร รายงานการเคลื่อนไหวทางบัญชี หน้าสำเนาสมุดบัญชีธนาคาร รายละเอียดเกี่ยวกับการสั่งซื้อและการชำระเงินค่าบริการ</h6><h6>
ข้อมูลทางธุรกิจ เช่น ชื่อบริษัท ชื่อร้านผู้ให้บริการบนแอปพลิเคชัน ประเภทของธุรกิจ ตำแหน่งงาน เลขประจำตัวผู้เสียภาษี ที่อยู่ผู้เสียภาษี ข้อมูลติดต่อทางธุรกิจ เป็นต้น</h6><h6>
ข้อมูลเอกสารทางธุรกิจ เช่น สำเนาหนังสือรับรองหรือทะเบียนการค้า สำเนาเอกสารทางภาษี</h6><h6>
ข้อมูลอื่น ๆ ที่เป็นข้อมูลส่วนบุคคลที่ท่านยินยอมนำส่งให้แก่บริษัทฯ เช่น เอกสารประกอบการลงทะเบียนใช้บริการที่อาจมีข้อมูลส่วนบุคคล บทความ คำติชม ข้อเสนอแนะ ภาพเคลื่อนไหว หรือเสียง เป็นต้น
 
</h6><h6>
3. ข้อมูลส่วนบุคคลที่เก็บรวบรวมโดยอัติโนมัติ

</h6><h6>

เมื่อท่านเยี่ยมชมเว็บไซต์ของบริษัทฯ บริษัทฯ อาจทำการเก็บรวบรวมข้อมูลบางประเภทของท่านโดยอัตโนมัติ ซึ่งรวมถึงแต่ไม่จำกัดเพียงข้อมูลดังต่อไปนี้

</h6><h6>

ข้อมูลทางเทคนิค เช่น IP Address, Cookie ID, ประวัติการใช้งานเว็บไซต์ (Activity Log) การตั้งค่า และข้อมูลเกี่ยวกับการเยี่ยมชมของท่าน</h6><h6>
ข้อมูลการใช้งานเว็บไซต์ เช่น ข้อมูลการค้นหา ข้อมูลการเข้าชมสื่อหรือเนื้อหาบนเว็บไซต์ เวลาตอบสนองของหน้าเว็บไซต์ ระยะเวลาที่ท่านเยี่ยมชมแต่ละหน้าเพจหรือข้อมูลอื่น ๆ ที่เกี่ยวกับวิธีการเยี่ยมชมและเข้าใช้งานเว็บไซต์ของท่าน
 
</h6><h6>
 

 

บริษัทฯ จะได้รับข้อมูลเหล่านี้เมื่อท่านเข้าเยี่ยมชมเว็บไซต์ของบริษัทฯ โดยเว็บไซต์ของบริษัทฯ จะบันทึกข้อมูลที่เบราว์เซอร์ของท่านส่งมาโดยอัตโนมัติ

</h6><h6>

4. วัตถุประสงค์ในการประมวลผลข้อมูลส่วนบุคคล

</h6><h6>

บริษัทฯ จะเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านตามคำขอ และ/หรือข้อตกลงที่ท่านได้ทำไว้กับบริษัทฯ ซึ่งรวมถึงแต่ไม่จำกัดเพียงวัตถุประสงค์ดังต่อไปนี้

</h6><h6>

(1) เพื่อดำเนินการตามคำขอของท่านก่อนการลงทะเบียนเข้าใช้บริการในฐานะร้านค้าบน HubSwitch Pro หรือบริการอื่นใดของบริษัทฯ และพิจารณาอนุมัติเกี่ยวกับการให้บริการ

</h6><h6>

(2) เพื่อตรวจสอบและยืนยันตัวตนของท่านก่อนบริษัทฯ อนุญาตให้ใช้บริการบน HubSwitch Pro หรือบริการอื่นใดที่เกี่ยวข้อง

</h6><h6>

(3) เพื่อให้บริการบน HubSwitch รวมถึงการให้บริการอื่น ๆ ที่เกี่ยวข้อง

</h6><h6>

(4) เพื่อดำเนินการชำระค่าบริการหรือค่าธรรมเนียมในบริการที่ท่านได้เลือกใช้กับบริษัทฯ

</h6><h6>

(5) เพื่อการแจ้งสิทธิประโยชน์ รายการส่งเสริมการขายต่าง ๆ การดำเนินกิจกรรมทางการตลาด การเชิญชวนเข้าร่วมกิจกรรมต่าง ๆ ของบริษัทฯ และสื่อสารเกี่ยวกับกิจกรรมดังกล่าว รวมทั้งนำเสนอบริการหรือสินค้าต่าง ๆ ที่ท่านอาจให้ความสนใจผ่านช่องทางการติดต่อที่ท่านได้ให้บริษัทฯ ไว้

</h6><h6>

(6) เพื่อใช้ในการติดต่อท่านเพื่อแก้ไขปัญหาจากข้อร้องเรียนต่าง ๆ หรือปัญหาอื่น ๆ ที่เกิดขึ้นจากการใช้บริการของบริษัทฯ และการเรียกเก็บค่าธรรมเนียมหรือค่าบริการจากท่าน

</h6><h6>

(7) เพื่อรวบรวมข้อเสนอแนะและคำแนะนำเพื่อใช้ในการ วิจัย ประเมิน พัฒนา และปรับปรุงการให้บริการ และฟีเจอร์ให้มีประสิทธิภาพและตอบสนองต่อความต้องการของท่านมากยิ่งขึ้น

</h6><h6>

(8) เพื่อการวางแผนการดำเนินการ การบริหาร จัดการภายในองค์กรของบริษัทฯ ปรับแต่ง ประเมิน และปรับปรุงการให้บริการเนื้อหา และการโฆษณาของบริษัทฯ

</h6><h6>

(9) ป้องกันและตรวจสอบการฉ้อโกงการละเมิดความปลอดภัยในการบริการหรือกิจกรรมต่าง ๆ ที่อาจเข้าข่ายผิดกฎหมายหรือเงื่อนไขการใช้งาน HubSwitch Pro ของบริษัทฯ

</h6><h6>

(10) เพื่อเป็นการปฏิบัติตามนโยบายข้อตกลงและเงื่อนไขของบริษัทฯ และเพื่อเป็นการปฏิบัติตามกฎหมายและกฎระเบียบของหน่วยงานราชการต่าง ๆ ที่เกี่ยวข้องในการให้บริการโดยบริษัทฯ

</h6><h6>

ทั้งนี้ หากข้อมูลส่วนบุคคลของท่านที่บริษัทฯ ได้เก็บรวบรวมตามที่ได้ระบุไว้ข้างต้นเป็นข้อมูลที่จำเป็นเพื่อให้บริษัทฯ ปฏิบัติให้เป็นไปตามกฎหมายหรือเพื่อการปฏิบัติตามสัญญาที่มีระหว่างท่านกับบริษัทฯ หากท่านไม่ให้ข้อมูลดังกล่าว บริษัทฯ อาจไม่สามารถจัดหาสินค้าหรือบริการให้แก่ท่านได้ รวมทั้งท่านไม่อาจอำนวยความสะดวกแก่ท่านในการใช้บริการหรือแจ้งข่าวสารให้แก่ท่านได้

</h6><h6>

การประมวลผลข้อมูลส่วนบุคคลของท่านขึ้นอยู่กับวิธีการที่ท่านมีปฏิสัมพันธ์กับบริษัทฯ โดยเหตุผลทางกฎหมายที่บริษัทฯ อาจอาศัยในการประมวลผลข้อมูลส่วนบุคคลของท่านมีดังต่อไปนี้ (1) ท่านได้ให้ความยินยอมสำหรับหนึ่งหรือมากกว่าหนึ่งวัตถุประสงค์ที่กำหนดไว้ (2) การประมวลผลข้อมูลนั้นจำเป็นในการปฏิบัติตามสัญญาระหว่างท่าน และ/หรือเพื่อการปฏิบัติก่อนการเข้าทำสัญญา (3) การประมวลผลข้อมูลนั้นมีความจำเป็นเพื่อการปฏิบัติตามกฎหมายที่บริษัทฯ มีหน้าที่ต้องปฏิบัติตาม (4) การประมวลผลข้อมูลนั้นเกี่ยวข้องกับการดำเนินภารกิจเพื่อประโยชน์สาธารณะของบริษัทฯ หรือปฏิบัติหน้าที่ในการใช้อำนาจรัฐที่ได้มอบให้บริษัทฯ หรือ (5) การประมวลผลข้อมูลนั้นเป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัทฯ หรือของบุคคลหรือนิติบุคคลอื่น

</h6><h6>

5. ผู้เยาว์

</h6><h6>

หากท่านมีอายุต่ำกว่า 20 ปีหรือมีข้อจำกัดความสามารถตามกฎหมาย ในการประมวลข้อมูลส่วนบุคคลของท่าน บริษทฯ อาจจำเป็นต้องได้รับความยินยอมจากให้ผู้ปกครองหรือผู้มีหน้าที่ดูแลและรับผิดชอบท่านตามกฎหมาย เว้นแต่ว่ากฎหมายอนุญาตให้กระทำได้โดยไม่ต้องขอความยินยอม หากบริษัทฯ ทราบว่ามีการเก็บรวบรวมข้อมูลส่วนบุคคลจากผู้เยาว์โดยไม่ได้รับความยินยอมจากผู้ปกครองหรือผู้มีหน้าที่ดูแลและรับผิดชอบตามกฎหมายหรือโดยที่ไม่มีข้อยกเว้นตามกฎหมาย บริษัทฯ จะดำเนินการลบข้อมูลดังกล่าวออกจากเซิร์ฟเวอร์ของบริษัทฯ โดยไม่ชักช้า

</h6><h6>

6. การเปิดเผยข้อมูลส่วนบุคคล

</h6><h6>

ความลับและข้อมูลส่วนบุคคลของท่านถือเป็นสิ่งสำคัญที่บริษัทฯ จะคอยดูแลให้ปลอดภัยและปราศจากการเข้าถึงโดยไม่ได้รับอนุญาต อย่างไรก็ตาม บริษัทฯ อาจจำเป็นจะต้องเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่บุคคลอื่นเพื่อการปฏิบัติตามรายละเอียดวัตถุประสงค์ที่ได้แจ้งข้างต้นเมื่อได้รับความยินยอมจากท่านหรือตามที่กฎหมายอนุญาตให้บริษัทฯ สามารถเปิดเผยได้ ซึ่งรวมถึงแต่ไม่จำกัดเพียงบุคคลหรือองค์กรดังต่อไปนี้

</h6><h6>

(1) บริษัทย่อย บริษัทในกลุ่ม หรือบริษัทในเครือ

</h6><h6>

บริษัทฯ อาจเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่บริษัทย่อย บริษัทในกลุ่ม หรือบริษัทในเครือของบริษัทฯ เท่าที่จำเป็นเพื่อปรับปรุงและพัฒนา HubSwitch Pro สินค้า หรือบริการของบริษัทฯ

</h6><h6>

(2) ผู้ให้บริการและลูกค้าบนแอปพลิเคชัน HubSwitch

</h6><h6>

บริษัทฯ อาจเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่ผู้ให้บริการของบริษัทฯ และลูกค้าที่เลือกใช้บริการจากร้านค้าบน HubSwitch เท่าที่จำเป็นเพือวัตถุประสงค์ในการให้บริการแก่ท่านและเพื่อการดำเนินงานในด้านต่าง ๆ ที่เกี่ยวข้องกับการให้บริการ เช่น การชำระเงิน การตลาด การพัฒนาสินค้าหรือบริการของบริษัทฯ เป็นต้น ทั้งนี้ โปรดทราบว่าบริษัทฯ ไม่สามารถเข้าถึงข้อมูลระหว่างท่านและผู้ให้บริการชำระเงินได้และข้อมูลดังกล่าวจะอยู่ภายใต้นโยบายความเป็นส่วนตัวของผู้ให้บริการนั้น ๆ สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการเก็บรวบรวมและวิธีการที่ผู้ให้บริการใช้ข้อมูลของท่าน โปรดตรวจสอบนโยบายความเป็นส่วนตัวของผู้ให้บริการผู้นั้น

</h6><h6>

(3) พันธมิตรทางธุรกิจ

</h6><h6>

บริษัทฯ อาจเปิดเผยข้อมูลบางอย่างกับพันธมิตรทางธุรกิจเพื่อติดต่อและประสานงานในการให้บริการสินค้าหรือบริการของบริษัทฯ โดยบริษัทฯ จะให้เพียงข้อมูลเท่าที่จำเป็นเท่านั้น

</h6><h6>

(4) การถ่ายโอนทางธุรกิจ

</h6><h6>

บริษัทฯ อาจเปิดเผยข้อมูล รวมถึงข้อมูลส่วนบุคคลของท่าน สำหรับการปรับโครงสร้างองค์กร การควบรวมหรือการขายกิจการ หรือการถ่ายโอนสินทรัพย์อื่น ๆ โดยฝ่ายที่รับโอนต้องปฏิบัติกับข้อมูลของท่านในลักษณะที่สอดคล้องกับนโยบายนี้ รวมถึงกฎหมายคุ้มครองข้อมูลส่วนบุคคลด้วย

</h6><h6>

(5) หน่วยงานรัฐ

</h6><h6>

ในบางกรณี บริษัทฯ อาจจำเป็นต้องเปิดเผยข้อมูลส่วนบุคคลของท่านหากมีความจำเป็นที่จะต้องปฏิบัติตามข้อกำหนดทางกฎหมายหรือเพื่อตอบสนองต่อคำขอทางราชการจากหน่วยงานของรัฐ

</h6><h6>

7. การจัดเก็บและการส่งหรือโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ

</h6><h6>

บริษัทฯ จะเก็บรักษาข้อมูลส่วนบุคคลของท่านในรูปแบบเอกสารและรูปแบบอิเล็กทรอนิกส์ บริษัทฯ เก็บรักษาข้อมูลส่วนบุคคลของท่านบนเซิร์ฟเวอร์ของบริษัทฯ ในประเทศไทย และบนระบบคลาวด์ นอกประเทศไทย

</h6><h6>

บริษัทฯ อาจมีการเปิดเผยหรือโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคล องค์กร หรือบนระบบคลาวด์ที่อยู่นอกประเทศไทย ทั้งนี้ หากมีการโอนข้อมูลส่วนบุคคลของท่านไปนอกประเทศไทย บริษัทฯ จะดำเนินการตามมาตรการความปลอดภัยต่าง ๆ เพื่อให้ท่านมั่นใจได้ว่าการโอนข้อมูลส่วนบุคคลของท่านไปยังประเทศปลายทางนั้นมีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลอย่างเพียงพอ หรือสอดคล้องกับกรณีอื่น ๆ ตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด

</h6><h6>

8. สิทธิในของเจ้าของข้อมูลส่วนบุคคล

</h6><h6>

เพื่อประโยชน์ในการรักษาความเป็นส่วนตัวคุ้มครองข้อมูลส่วนบุคคลของท่าน ท่านมีสิทธิในฐานะเจ้าของข้อมูลภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคลเมื่อบริษัทฯ ได้ประมวลผลข้อมูลส่วนบุคคลของท่าน โดยท่านสามารถใช้สิทธิของท่านได้โดยไม่เสียค่าใช้จ่ายภายใต้ข้อยกเว้นตามกฎหมาย

</h6><h6>

สิทธิในข้อมูลส่วนบุคคลของท่านมีดังต่อไปนี้

</h6><h6>

1. สิทธิขอถอนความยินยอม

</h6><h6>

ท่านมีสิทธิที่จะถอนความยินยอมที่ท่านได้ให้ไว้แก่บริษัทฯ เมื่อใดก็ได้ตลอดเวลา อย่างไรก็ตาม การถอนความยินยอมของท่านจะไม่ส่งผลกระทบต่อการประมวลผลของข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมแก่เราไว้ก่อนหน้าแล้วโดยชอบด้วยกฎหมาย ทั้งนี้ ท่านอาจถอนความยินยอมในการที่จะไม่รับข้อมูลหรือสื่อทางการตลาดใด ๆ จากบริษัทฯ โดยตัวท่านเองก็ได้ โดยเข้าไปตั้งค่าใน HubSwitch Pro เพื่อปิดการแจ้งเตือนเกี่ยวกับการรับข่าวสารจากบริษัทฯ

</h6><h6>

2. สิทธิในการเข้าถึงข้อมูล

</h6><h6>

ท่านมีสิทธิขอเข้าถึงข้อมูลส่วนบุคคลของท่านที่อยู่ภายใต้ความรับผิดชอบของบริษัทฯ และร้องขอให้บริษัทฯ ทำสำเนาข้อมูลส่วนบุคคลดังกล่าวให้แก่ท่าน รวมถึงขอให้บริษัทฯ เปิดเผยว่าบริษัทฯ บริษัทฯ ได้ข้อมูลส่วนบุคคลของท่านมาได้อย่างไร

</h6><h6>

3. สิทธิในการแก้ไขข้อมูลให้ถูกต้อง

</h6><h6>

ท่านมีสิทธิขอเปลี่ยนแปลงข้อมูลส่วนบุคคลของท่านให้ถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิดได้

</h6><h6>

4. สิทธิในการลบหรือทำลายข้อมูล

</h6><h6>

ท่านมีสิทธิร้องขอให้บริษัทฯ ลบหรือทำลายข้อมูลส่วนบุคคลของท่านหรือทำให้ข้อมูลส่วนบุคคลของท่านที่อยู่ภายใต้การดูแลของบริษัทฯ เป็นข้อมูลที่ไม่สามารถระบุตัวตนได้ หากท่านเชื่อว่าข้อมูลส่วนบุคคลของท่านถูกเก็บรวบรวม ใช้ หรือเปิดเผยโดยไม่ชอบด้วยกฎหมาย หรือเมื่อท่านเห็นว่าบริษัทฯ หมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ที่เกี่ยวข้องในนโยบายฉบับนี้ หรือเมื่อท่านได้ใช้สิทธิขอถอนความยินยอมหรือใช้สิทธิขอคัดค้านตามที่มีการแจ้งท่านไว้ข้างต้น

</h6><h6>

5. สิทธิในการระงับการใช้ข้อมูลข้อมูล

</h6><h6>

ท่านมีสิทธิในการร้องขอให้ บริษัทฯ ระงับการใช้ข้อมูลส่วนบุคคลของท่านชั่วคราวในกรณีที่บริษัทฯ อยู่ระหว่างตรวจสอบตามคำร้องขอใช้สิทธิแก้ไขข้อมูลหรือขอคัดค้านของท่าน หรือกรณีอื่นใดที่บริษัทฯ หมดความจำเป็นและต้องลบหรือทำลายข้อมูลส่วนบุคคลของท่านตามกฎหมายที่เกี่ยวข้องแต่ท่านขอให้ระงับการใช้แทน

</h6><h6>

6. สิทธิในการคัดค้าน

</h6><h6>

ท่านมีสิทธิขอคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านในเวลาใดก็ได้ หากการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านมีเพื่อการดำเนินงานที่จำเป็นภายใต้ประโยชน์โดยชอบด้วยกฎหมายของบริษัทฯ หรือของบุคคลหรือนิติบุคคลอื่น หรือเพื่อดำเนินการตามภารกิจเพื่อสาธารณประโยชน์ เว้นแต่การเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลนั้นจะไม่เกินขอบเขตที่ท่านสามารถคาดหมายได้อย่างสมเหตุผล

</h6><h6>

7. สิทธิขอถ่ายโอนข้อมูล

</h6><h6>

ท่านมีสิทธิขอรับข้อมูลส่วนบุคคลของท่านในกรณีที่บริษัทฯ ได้จัดทำข้อมูลส่วนบุคคลนั้นอยู่ในรูปแบบให้สามารถอ่านหรือใช้งานได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติและสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ รวมทั้งมีสิทธิขอให้บริษัทฯ ส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นเมื่อสามารถทำได้ด้วยวิธีการอัตโนมัติและมีสิทธิขอรับข้อมูลส่วนบุคคลที่บริษัทฯ มีการส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นโดยตรง เว้นแต่ไม่สามารถดำเนินการได้เพราะเหตุทางเทคนิค

</h6><h6>

8. สิทธิในการร้องเรียน

</h6><h6>

ท่านมีสิทธิร้องเรียนต่อผู้มีอำนาจตามกฎหมายที่เกี่ยวข้อง หากท่านเชื่อว่าการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน เป็นการกระทำในลักษณะที่ฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายที่เกี่ยวข้อง          ท่านสามารถใช้สิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคลตามข้างต้นได้ โดยติดต่อมายังบริษัทฯ ตามรายละเอียดข้างท้ายของนโยบายฉบับนี้ โดยบริษัทฯ จะแจ้งผลการดำเนินการภายในระยะเวลา 30 วัน นับแต่วันที่ได้รับคำขอใช้สิทธิจากท่านตามแบบฟอร์มหรือวิธีการที่บริษัทฯ กำหนด ทั้งนี้ หากบริษัทฯ ปฏิเสธคำขอของท่านบริษัทฯ จะแจ้งเหตุผลของการปฏิเสธให้ท่านทราบผ่านช่องทางต่าง ๆ เช่น ข้อความ (SMS) อีเมล โทรศัพท์ ไปรษณีย์ เป็นต้น

</h6><h6>

9. ระยะเวลาในการจัดเก็บข้อมูลส่วนบุคคลของท่าน

</h6><h6>

บริษัทฯ จะขอจัดเก็บข้อมูลส่วนบุคคลของท่านไว้ตลอดระยะเวลาที่มีความจำเป็นและในขณะที่ท่านมีความสัมพันธ์กับบริษัทฯ และเพื่อวัตถุประสงค์ในการดำเนินงานตามที่ได้ระบุไว้ในนโยบายฉบับนี้ เช่น การรักษาการให้บริการของบริษัทฯ การปฏิบัติตามข้อผูกพันทางกฎหมายของบริษัทฯ  หากท่านร้องขอให้ลบ ทำลาย หรือทำให้ข้อมูลส่วนบุคคลของท่านเป็นข้อมูลที่ไม่สามารถระบุตัวตน บริษัทฯ จะดำเนินการลบ ทำลาย หรือทำให้ข้อมูลดังกล่าวเป็นข้อมูลที่ไม่สามารถระบุตัวตน ภายในระยะเวลาไม่เกิน 30 วันนับแต่วันที่ได้รับคำร้องขอ เว้นแต่บริษัทฯ จะได้รับอนุญาตหรือถูกกำหนดโดยกฎหมายให้เก็บข้อมูลส่วนบุคคลที่จำเป็นไว้เป็นระยะเวลาที่กฎหมายได้กำหนดไว้ และ/หรือ ในกรณีที่มีความจำเป็นตามอำนาจหน้าที่และวัตถุประสงค์ในการดำเนินงานโดยชอบด้วยกฎหมายของบริษัทฯ เช่น การป้องกันการฉ้อโกง พันธะทางด้านกฎหมาย การรวบรวมหลักฐานในการดำเนินคดี หรือเพื่อที่จะรักษาความปลอดภัยให้กับท่าน โดยมีมาตรการที่เหมาะสมเพื่อคุ้มครองสิทธิขั้นพื้นฐาน และประโยชน์ของเจ้าของข้อมูลส่วนบุคคล

</h6><h6>

10. เทคโนโลยีติดตามตัวบุคคล (Cookies)

</h6><h6>

เว็บไซต์ของบริษัทฯ ใช้ “คุกกี้” เพื่อเพิ่มประสบการณ์การใช้งานของท่านให้สมบูรณ์และมีประสิทธิภาพมากยิ่งขึ่น

</h6><h6>

คุกกี้ คือ ไฟล์ข้อความที่บริษัทฯ จัดเก็บไว้ในฮาร์ดไดรฟ์ของท่านโดยเว็บเพจเซิร์ฟเวอร์ คุกกี้ไม่สามารถใช้เพื่อเปิดโปรแกรมหรือเพื่อนำส่งไวรัสเข้าสู่คอมพิวเตอร์ของท่าน คุกกี้ถูกเลือกใช้ให้เป็นเอกลักษณ์แก่ท่านและจะสามารถอ่านได้โดยเว็บเซิร์ฟเวอร์ของโดเมนที่ได้นำคุกกี้มาใช้กับท่าน

</h6><h6>

บริษัทฯ อาจใช้คุกกี้เพื่อเก็บรวบรวม จัดเก็บ และติดตามข้อมูลเพื่อวัตถุประสงค์ทางสถิติเพื่อดำเนินการเว็บไซต์ โดยท่านความสามารถเลือกได้ว่าจะยอมรับหรือปฏิเสธคุกกี้ เว็บเบราว์เซอร์ส่วนใหญ่ยอมรับคุกกี้โดยอัตโนมัติ ทั้งนี้ ท่านสามารถทำการแก้ไขการตั้งค่าเบราว์เซอร์ของท่านเพื่อปฏิเสธการใช้คุกกี้ได้หากท่านต้องการ หากท่านเลือกที่จะปฏิเสธคุกกี้ท่านจะไม่สามารถใช้และพบกับคุณสมบัติพิเศษของเว็บไซต์ของบริษัทฯ ได้

</h6><h6>

11. การโฆษณาและการแจ้งข่าวสาร

</h6><h6>

เพื่อประโยชน์ในการได้รับบริการบน HubSwitch Pro หรือบริการของบริษัทฯ บริษัทฯ อาจใช้ข้อมูลของท่านเพื่อวิเคราะห์และปรับปรุงสินค้าหรือบริการ และทำการแจ้งข่าวสารผ่านการแจ้งเตือนบน HubSwitch Pro และช่องทางอื่น ๆ บริษัทฯ จะใช้ข้อมูลดังกล่าวเพื่อให้พัฒนา HubSwitch Pro และสินค้าหรือบริการของบริษัทฯ ให้เหมาะสมกับความต้องการของท่าน

</h6><h6>

HubSwitch Pro และเว็บไซต์ของบริษัทฯ อาจแสดงโฆษณาจากบุคคลที่สามเพื่ออำนวยความสะดวกในการบริการของบริษัทฯ บุคคลที่สามเหล่านี้อาจเข้าถึงข้อมูลส่วนบุคคลของท่านเพื่อดำเนินการตามสิ่งที่ได้แสดงไว้เท่านั้นและมีหน้าที่ไม่เปิดเผยหรือใช้ข้อมูลของท่านเพื่อวัตถุประสงค์อย่างอื่น

</h6><h6>

บริษัทฯ จะไม่ใช้ระบบการตัดสินใจอัตโนมัติ (automated decision-making) โดยปราศจากการบุคคลกำกับดูแล รวมถึงการทำโปรไฟล์ลิ่ง (profiling) ในลักษณะที่ก่อให้เกิดผลกระทบกับท่านอย่างมีนัยสำคัญ

</h6><h6>

บริษัทฯ อาจส่งข้อมูลหรือจดหมายข่าวไปยังอีเมลของท่านตามข้อมูลที่ท่านได้ให้ไว้กับบริษัทฯ โดยมีวัตถุประสงค์เพื่อเสนอสินค้าหรือบริการที่น่าสนให้แก่ท่าน หากท่านไม่ต้องการรับการติดต่อสื่อสารจากบริษัทฯ ผ่านทางอีเมลหรือผ่านการแจ้งเตือนบน HubSwitch Pro อีกต่อไป ท่านสามารถกด “ยกเลิกการติดต่อ” ในลิงก์อีเมลหรือติดต่อมายังอีเมลของบริษัทฯ ได้ หรือท่านสามารถกดยกเลิกการรับข่าวสารบน HubSwitch Pro ได้โดยตัวท่านเองผ่านการตั้งค่า

</h6><h6>

12. การรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล

</h6><h6>

บริษัทฯ จะรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของท่านไว้ตามหลักการ การรักษาความลับ (confidentiality) ความถูกต้องครบถ้วน (integrity) และสภาพพร้อมใช้งาน (availability) ทั้งนี้ เพื่อป้องกันการสูญหาย เข้าถึง ใช้ เปลี่ยนแปลง แก้ไข หรือเปิดเผย บริษัทฯ จะจัดให้มีมาตรการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล ซึ่งครอบคลุมถึงมาตรการป้องกันด้านการบริหารจัดการ (administrative safeguard) มาตรการป้องกันด้านเทคนิค (technical safeguard) และมาตรการป้องกันทางกายภาพ (physical safeguard) ในเรื่องการเข้าถึงหรือควบคุมการใช้งานข้อมูลส่วนบุคคล (access control) นอกจากนี้ พนักงาน ลูกจ้าง และผู้ให้บริการภายนอกของบริษัทฯ มีหน้าที่ต้องรักษาความลับของข้อมูลส่วนบุคคลของเจ้าของข้อมูลและต้องปฏิบัติตามมาตรฐานและนโยบายการรักษาความปลอดภัยของข้อมูลที่เคร่งครัดเมื่อมีการใช้ ส่ง โอน หรือประมวลผลใด ๆ กับข้อมูลส่วนบุคคลของท่าน

</h6><h6>

13. การแจ้งเหตุละเมิดข้อมูลส่วนบุคคล

</h6><h6>

ในกรณีที่มีเหตุละเมิดข้อมูลส่วนบุคคลของท่านเกิดขึ้น บริษัทฯ จะแจ้งให้สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลทราบโดยไม่ชักช้าภายใน 72 ชั่วโมง นับแต่ทราบเหตุละเมิดข้อมูลส่วนบุคคลเท่าที่บริษัทฯ สามารถกระทำได้ ในกรณีที่การละเมิดมีความเสี่ยงสูงที่จะมีผลกระทบต่อสิทธิและเสรีภาพของท่าน บริษัทฯ จะแจ้งการละเมิดให้ท่านทราบพร้อมกับแนวทางการเยียวยาโดยไม่ชักช้าผ่านช่องทางต่าง ๆ เช่น เว็บไซต์ ข้อความ (SMS) อีเมล โทรศัพท์ ไปรษณีย์ เป็นต้น

</h6><h6>

14. การเชื่อมต่อไปยังเว็บไซต์อื่น

</h6><h6>

นโยบายฉบับนี้ใช้สำหรับการให้บริการ HubSwitch Pro และการใช้งานเว็บไซต์ของบริษัทฯ เท่านั้น หากท่านเข้าชมเว็บไซต์อื่น ๆ ที่ไม่ใช่ของบริษัทฯ แม้จะผ่านช่องทาง HubSwitch Pro หรือเว็บไซต์ของบริษัทฯ ก็ตาม การคุ้มครองข้อมูลส่วนบุคคลต่างของเว็บไซต์ดังกล่าวจะเป็นไปตามนโยบายความเป็นส่วนตัวของผู้ให้บริการเว็บไซต์นั้น ซึ่งบริษัทฯ ไม่มีส่วนเกี่ยวข้องด้วย โปรดตรวจสอบนโยบายความเป็นส่วนตัวของผู้ให้บริการเว็บไซต์นั้นโดยตรงเพื่อทำความเข้าใจรายละเอียดเพิ่มเติม

</h6><h6>

15. การแก้ไขและเปลี่ยนแปลงนโยบายความเป็นส่วนตัว

</h6><h6>

บริษัทฯ ขอสงวนสิทธิในการแก้ไขเปลี่ยนแปลงนโยบายฉบับนี้เป็นครั้งคราว บริษัทฯ จะเผยแพร่การเปลี่ยนแปลงดังกล่าวบนเว็บไซต์หรือหน้าเว็บไซต์ของบริษัทฯ สำหรับกรณีที่เป็นการเปลี่ยนแปลงในสาระสำคัญ บริษัทฯ จะแจ้งให้ท่านทราบถึงการเปลี่ยนแปลงดังกล่าวโดยไม่ชักช้า

</h6><h6>

นโยบายฉบับนี้แก้ไขล่าสุดและมีผลใช้บังคับตั้งแต่วันที่ [•] 
</h6></>
    )
}